import { type TProfile as TApiProfile } from '@core/api'

import { type TProfile } from '@core/models'

export const convertProfile = (apiProfile: TApiProfile): TProfile => {
    const {
        about,
        email,
        facebook,
        name,
        location,
        website,
        twitter,
        browsable,
        id,
        avatar,
        username,
    } = apiProfile

    return {
        id,
        displayName: name,
        about,
        email,
        facebook,
        location,
        website,
        twitter,
        isBrowsable: browsable,
        avatarUrl: avatar,
        username,
    }
}
